import { MutationTuple, useMutation } from '@apollo/client';

import {
  CREATE_COMPANY_FOR_ORGANIZATION,
  CreateCompanyForOrganizationMutation,
  CreateCompanyForOrganizationMutationVariables,
} from '@neo.tax/shared/graphql';
import { useCurrentUser } from '@neo.tax/shared/hooks';

export const useCreateCompanyForOrganization = (): MutationTuple<
  CreateCompanyForOrganizationMutation,
  CreateCompanyForOrganizationMutationVariables
> => {
  const { user } = useCurrentUser();
  return useMutation<CreateCompanyForOrganizationMutation, CreateCompanyForOrganizationMutationVariables>(
    CREATE_COMPANY_FOR_ORGANIZATION,
    {
      update: (cache, { data }) => {
        if (!data?.createCompanyForOrganization || !user) return;
        cache.modify({
          fields: {
            getCompaniesForUser: (existingCompaniesRefs) => {
              const newRef = cache.identify(data.createCompanyForOrganization);
              return [...existingCompaniesRefs, { __ref: newRef }];
            },
          },
        });
        cache.modify({
          id: cache.identify(user),
          fields: {
            companies: (existingCompaniesRefs) => {
              const newRef = cache.identify(data.createCompanyForOrganization);
              return [...existingCompaniesRefs, { __ref: newRef }];
            },
          },
        });
      },
    },
  );
};
